import { render, staticRenderFns } from "./CanvasDrawing.vue?vue&type=template&id=0da0abfc&scoped=true"
import script from "./CanvasDrawing.vue?vue&type=script&lang=js"
export * from "./CanvasDrawing.vue?vue&type=script&lang=js"
import style0 from "./CanvasDrawing.vue?vue&type=style&index=0&id=0da0abfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0abfc",
  null
  
)

export default component.exports